<template>
  <div id="editarSimpleAcuerdoLineas">
    <ui-modal
      ref="modal"
      @close="actionSetVisibleModalEditarSimpleAcuerdoLinea(false); ActionSetZindexModal(false);actionSetEditarSimpleAcuerdoLinea(false)"
      :title="`Editar Acuerdo de Línea`"
      size="auto">

      <div>

        <acuerdo-lineas-form-component
          class="acuerdo-lineas-form-component"
          :form="addAcuerdoLineasForm"
          :idContrato="idContrato"
        />

      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">

        <button class="btn btn-default"
                @click="closeModal('modal')">
          Cerrar
        </button>

        <button class="btn btn-outline-warning"
                @click="validarFormulario"
                id="buttonRef1111">
          Actualizar
        </button>

      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);
// Select UI
import UiModal from "keen-ui/src/UiModal";

// Constantes
import {
  updateAcuerdoLineas,
  getAcuerdosLineas,
} from "@/constants/lineas";

import AcuerdoLineasFormComponent from "./AcuerdoLineasFormComponent";

export default {
  props: ["dataActualizar", "addAcuerdoLineasForm", "idContrato"],
  data() {
    return {
      titulo: "",
      dataAux: this.data,
    };
  },
  components: {
    UiModal,
    AcuerdoLineasFormComponent
  },
  computed: {
    ...mapState("lineas", ["visibleModalEditarSimpleAcuerdoLinea"]),
    ...mapState("lineas", ["dataListaNaviera", "dataListaPOD", "dataListaPOL"]),
    ...mapState(["puertos"]),
  },
  methods: {
    // Acciones de Vuex
    ...mapActions("lineas", ["actionSetVisibleModalEditarSimpleAcuerdoLinea", "actionSetEditarSimpleAcuerdoLinea", "actionSetDataListarTarifasAcuerdosLineas"]),
    ...mapActions(["ActionSetZindexModal"]),

    // Función para actualizar url en state
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef1111");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async loadingData() {

      let dataAcuerdoLineaBD = await getAcuerdosLineas();

      this.dataAux = dataAcuerdoLineaBD;

      await this.actionSetDataListarTarifasAcuerdosLineas(
        dataAcuerdoLineaBD.data_table
      );
    },
    async validarFormulario() {

      if (this.addAcuerdoLineasForm.naviera_id.value.id === "") {
        this.$vToastify.error("Campo Naviera vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.naviera_salida.value.id === "") {
        this.$vToastify.error("Campo Naviera Salida vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.pol.value.id === "") {
        this.$vToastify.error("Campo POL vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.pod.value.id === "") {
        this.$vToastify.error("Campo POD vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.from_date.value === "") {
        this.$vToastify.error("Campo DESDE vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.to_date.value === "") {
        this.$vToastify.error("Campo HASTA vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.transit_time.value === "") {
        this.$vToastify.error("Campo TT vacío", "¡Error!");
        return;
      }

      if (!this.addAcuerdoLineasForm.neta.value) {
        this.$vToastify.error("Campo Neta (Costo) vacío", "¡Error!");
        return;
      }

      if (!this.addAcuerdoLineasForm.public_value.value) {
        this.$vToastify.error("Campo Pública (Venta) vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.container_id.value.id === "") {
        this.$vToastify.error("Campo Unidad vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.products_category_id.value.id === "") {
        this.$vToastify.error("Campo Commodity vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.atmosphere_id.value.id === "") {
        this.$vToastify.error("Campo Atmósfera vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.free_days_embark.value === "") {
        this.$vToastify.error("Campo Free Days Origen vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.plug_days_embark.value === "") {
        this.$vToastify.error("Campo Plug Days Origen vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.free_days_land.value === "") {
        this.$vToastify.error("Campo Free Days Destino vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.plug_days_land.value === "") {
        this.$vToastify.error("Campo Plug Days Destino vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.type_contract.value.id === "") {
        this.$vToastify.error("Campo Tipo Contrato vacío", "¡Error!");
        return;
      }

      await this.actualizarAcuerdoLineaSimple();

    },
    async actualizarAcuerdoLineaSimple() {

      this.estadoButton("Actualizando...");

      this.$vToastify.loader("Actualizando Acuerdo de Líneas...");

      let tariff_lines = [];

      tariff_lines.push({
        atmosphere_id:        this.addAcuerdoLineasForm.atmosphere_id.value.id,
        coldtreatment:
          typeof this.addAcuerdoLineasForm.coldtreatment.value === "object"
            ? (this.addAcuerdoLineasForm.coldtreatment.value.name || "")
            : (this.addAcuerdoLineasForm.coldtreatment.value || ""),
        comment:              this.addAcuerdoLineasForm.comment.value,
        container_id:         this.addAcuerdoLineasForm.container_id.value.id,
        contract:             this.addAcuerdoLineasForm.contract.value,
        country_id:           this.addAcuerdoLineasForm.country_id.value,
        free_days_embark:     this.addAcuerdoLineasForm.free_days_embark.value,
        free_days_land:       this.addAcuerdoLineasForm.free_days_land.value,
        from_date:            this.addAcuerdoLineasForm.from_date.value,
        genset:               this.addAcuerdoLineasForm.genset.value,
        get_out:               this.addAcuerdoLineasForm.get_out.value,
        id_by_country:        this.addAcuerdoLineasForm.id_by_country.value,
        naviera_id:           this.addAcuerdoLineasForm.naviera_id.value.id,
        naviera_salida_id:    this.addAcuerdoLineasForm.naviera_salida.value.id,
        neta:                 this.addAcuerdoLineasForm.neta.value,
        plug_days_embark:     this.addAcuerdoLineasForm.plug_days_embark.value,
        plug_days_land:       this.addAcuerdoLineasForm.plug_days_land.value,
        pod:                  this.addAcuerdoLineasForm.pod.value.id,
        pol:                  this.addAcuerdoLineasForm.pol.value.id,
        products_category_id: this.addAcuerdoLineasForm.products_category_id.value.id,
        public_value:         this.addAcuerdoLineasForm.public_value.value,
        tariff_contract_id:   this.addAcuerdoLineasForm.tariff_contract_id.value.id,
        to_date:              this.addAcuerdoLineasForm.to_date.value,
        transit_time:         this.addAcuerdoLineasForm.transit_time.value,
        type_contract:        this.addAcuerdoLineasForm.type_contract.value.id,
        id: this.addAcuerdoLineasForm.id.value,
      });

      let dataParaEnviar = { tariff_lines };

      let sql = await updateAcuerdoLineas(dataParaEnviar);

      if (!sql.error) {

        await this.loadingData();

        this.estadoButton("Actualizar", false);

        this.$vToastify.stopLoader();

        this.$vToastify.success("Acuerdo de Linea actualizado con éxito","¡Realizado!");

        this.closeModal("modal");

      } else {

        this.estadoButton("Actualizar", false);

        this.$vToastify.stopLoader();

        this.$vToastify.error('Se produjo un error al actualizar el Acuerdo de Líneas', '¡No se ha podido actualizar!');

      }
    },
  },
  watch: {
    visibleModalEditarSimpleAcuerdoLinea: function (_new) {
      let me = this;
      _new && me.openModal("modal");
    },

    dataActualizar: function (_new) {
      // Titulo de modal
      this.titulo = _new.data[0];
      // Formulario
      this.titulo = _new.data[0];
      
    },
  },
};
</script>

<style>
#editarSimpleAcuerdoLineas .modal-editar-simple-acuerdo-linea .ui-modal__container {
  width: 100% !important;
  /* margin-right: 150% !important; */
}

/* .Heading {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
  height: 50px;
} */
.Heading2 {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
  height: 50px;
  width: 80px;
}
.HeadingMitad {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
  height: 40px;
}

.Cell {
  border: groove;
  border-width: thin;
}
.Altura {
  height: 60px;
}
.AlturaMitad {
  height: 30px;
}
.form-control.input-sm {
  height: 30px !important;
  min-width: auto !important;
}

.acuerdo-lineas-form-component {
  width: 90vw;
}
</style>
